"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationCosts = exports.getCosts = exports.calcPriceDiscount = void 0;
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _upsellSelectors = require("../../store/upsell/upsellSelectors");
var _constants = require("../../utils/constants");
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _react = require("react");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
var _useCustomer = require("../questionnaire/useCustomer");
var _services = require("../../services");
const getCosts = product => {
  var _product$price2, _product$price3, _recurringPriceDetail, _recurringPriceDetail2, _recurringPriceDetail3, _upfrontPriceDetails, _upfrontPriceDetails2, _recurringPriceDetail4, _recurringPriceDetail5, _recurringPriceDetail6;
  let upfrontPriceDetails, recurringPriceDetails, recurringPriceDetailsAfterDiscount;
  if (Array.isArray(product.price)) {
    var _product$price;
    upfrontPriceDetails = (_product$price = product.price) === null || _product$price === void 0 ? void 0 : _product$price.find(el => el.priceType === _constants.PRICE_TYPES.UP_FRONT);
  } else if ((product === null || product === void 0 ? void 0 : (_product$price2 = product.price) === null || _product$price2 === void 0 ? void 0 : _product$price2.priceType) === 'upfront') {
    upfrontPriceDetails = product.price;
  }
  if (Array.isArray(product.price)) {
    recurringPriceDetails = product.price.find(el => el.priceType === _constants.PRICE_TYPES.RECURRING);
    recurringPriceDetailsAfterDiscount = product.price.find(el => el.priceType === _constants.PRICE_TYPES.COMMERCE_PRICE);
  } else if ((product === null || product === void 0 ? void 0 : (_product$price3 = product.price) === null || _product$price3 === void 0 ? void 0 : _product$price3.priceType) === _constants.PRICE_TYPES.RECURRING) {
    recurringPriceDetails = product.price;
  }
  const termDuration = ((_recurringPriceDetail = recurringPriceDetails) === null || _recurringPriceDetail === void 0 ? void 0 : _recurringPriceDetail.durationAmount) || 0;
  const termUnit = ((_recurringPriceDetail2 = recurringPriceDetails) === null || _recurringPriceDetail2 === void 0 ? void 0 : _recurringPriceDetail2.durationUnit) || '';
  const termCost = (_recurringPriceDetail3 = recurringPriceDetails) === null || _recurringPriceDetail3 === void 0 ? void 0 : _recurringPriceDetail3.priceValue;
  const upfrontCost = (_upfrontPriceDetails = upfrontPriceDetails) === null || _upfrontPriceDetails === void 0 ? void 0 : _upfrontPriceDetails.priceValue;
  const discount = (_upfrontPriceDetails2 = upfrontPriceDetails) === null || _upfrontPriceDetails2 === void 0 ? void 0 : _upfrontPriceDetails2.discount;
  const termCostAfterDiscount = (_recurringPriceDetail4 = recurringPriceDetailsAfterDiscount) === null || _recurringPriceDetail4 === void 0 ? void 0 : _recurringPriceDetail4.priceValue;
  const totalCost = (_recurringPriceDetail5 = recurringPriceDetails) !== null && _recurringPriceDetail5 !== void 0 && _recurringPriceDetail5.durationAmount ? ((_recurringPriceDetail6 = recurringPriceDetails) === null || _recurringPriceDetail6 === void 0 ? void 0 : _recurringPriceDetail6.priceValue) * termDuration : upfrontCost;
  return {
    termDuration,
    termUnit,
    termCost,
    upfrontCost,
    totalCost,
    discount,
    termCostAfterDiscount
  };
};
exports.getCosts = getCosts;
const getAdditionalCosts = (product, additionalPlans, isCustomer) => {
  var _product$price4, _product$price5;
  if (!product) return;
  const price = (_product$price4 = product.price) === null || _product$price4 === void 0 ? void 0 : _product$price4.find(el => el.priceType === _constants.PRICE_TYPES.LIST_ADDITIONAL_PLAN_PRICE);
  const priceAfterDiscount = (_product$price5 = product.price) === null || _product$price5 === void 0 ? void 0 : _product$price5.find(el => el.priceType === _constants.PRICE_TYPES.COMMERCE_ADDITIONAL_PLAN_PRICE);
  const termDuration = (price === null || price === void 0 ? void 0 : price.durationAmount) || 0;
  const termUnit = (price === null || price === void 0 ? void 0 : price.durationUnit) || '';
  const termCost = price === null || price === void 0 ? void 0 : price.priceValue;
  let totalCost = termCost * Number(additionalPlans);
  const termCostAfterDiscount = priceAfterDiscount === null || priceAfterDiscount === void 0 ? void 0 : priceAfterDiscount.priceValue;
  let totalCostAfterDiscount = termCostAfterDiscount * Number(additionalPlans);
  if (isCustomer) {
    totalCost = additionalPlans === 1 ? 0 : termCost * Number(additionalPlans - 1);
    totalCostAfterDiscount = additionalPlans === 1 ? 0 : termCostAfterDiscount * Number(additionalPlans - 1);
  }
  return {
    termDuration,
    termUnit,
    termCost,
    totalCost,
    termCostAfterDiscount,
    totalCostAfterDiscount
  };
};
const getUpfrontPrice = (product, upsellPriceValue) => {
  return product.productOfferingPrice[0].priceType === 'upfront' ? upsellPriceValue : 0;
};
const getRecurringPrice = (product, upsellPriceValue) => {
  return product.productOfferingPrice[0].priceType === 'upfront' ? 0 : upsellPriceValue;
};
const getUpsellCosts = products => {
  let totalUpsellUpfrontCost = 0;
  let totalUpsellReccuringCost = 0;
  products.forEach(product => {
    const upsellPriceValue = product.productOfferingPrice[0].price.value;
    const upsellUpfrontCost = product.selectedPrice ? product.selectedPrice.upfront : getUpfrontPrice(product, upsellPriceValue);
    const upsellReccuringCost = product.selectedPrice ? product.selectedPrice.monthlyPrice : getRecurringPrice(product, upsellPriceValue);
    totalUpsellUpfrontCost += upsellUpfrontCost;
    totalUpsellReccuringCost += upsellReccuringCost;
  });
  return {
    totalUpsellUpfrontCost,
    totalUpsellReccuringCost
  };
};
const calcPriceDiscount = function () {
  let discount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const metadata = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectMetadata);
  if (!discount) return {
    discountPriceValue: 0,
    discountPercentage: 0
  };
  let discountPrices = {};
  const HandsetParser = new _services.Parsers.HandsetParser({
    metadata
  });
  const showDiscountData = HandsetParser.showDiscountData();
  if (showDiscountData) {
    discountPrices = {
      discountPriceValue: discount.totalDiscountValue,
      discountPercentage: discount.totalDiscountPercentage
    };
  } else {
    discountPrices = {
      discountPriceValue: discount.onlineDiscountValue,
      discountPercentage: discount.onlineDiscountPricePercentage
    };
  }
  return discountPrices;
};
exports.calcPriceDiscount = calcPriceDiscount;
const useRecommendationCosts = () => {
  var _costs$handset, _costs$plan, _costs$handset$termDu, _costs$handset2, _costs$plan$termDurat, _costs$plan2, _costs$handset$upfron, _costs$handset3, _costs$plan$upfrontCo, _costs$plan3, _costs$upsell$totalUp, _costs$upsell, _costs$connectivityPl, _costs$connectivityPl2, _costs$broadband$upfr, _costs$broadband, _costs$businessSoluti, _costs$businessSoluti2, _costs$addon$upfrontC, _costs$addon, _costs$handset$termCo, _costs$handset4, _costs$plan$termCost, _costs$plan4, _costs$additionalPlan, _costs$additionalPlan2, _costs$upsell$totalUp2, _costs$upsell2, _costs$connectivityPl3, _costs$connectivityPl4, _costs$broadband$term, _costs$broadband2, _costs$businessSoluti3, _costs$businessSoluti4, _costs$handset$termCo2, _costs$handset5, _costs$plan$termCostA, _costs$plan5, _costs$additionalPlan3, _costs$additionalPlan4, _costs$upsell$totalUp3, _costs$upsell3, _costs$connectivityPl5, _costs$connectivityPl6, _costs$broadband$term2, _costs$broadband3, _costs$businessSoluti5, _costs$businessSoluti6, _costs$addon$termCost, _costs$addon2, _costs$handset6, _costs$handset7, _costs$handset8;
  const selectedHandsetVariant = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedHandsetVariant);
  const selectedPlanVariant = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedPlanVariant);
  const selectedProductOfferingVariant = (0, _useAppSelector.useAppSelector)(_upsellSelectors.selectSelectedUpsellProductOfferings);
  const selectedBroadbandVariant = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedBroadbandVariant);
  const selectedBusinessSolutionVariant = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedBusinessSolutionVariant);
  const connectivityPlan = (0, _useAppSelector.useAppSelector)(_upsellSelectors.selectConnectivityPlan);
  const selectedHandset = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedHandset);
  const selectedPlan = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedPlan);
  const additionalPlans = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectAdditionalPlans);
  const {
    isCustomer
  } = (0, _useCustomer.useCustomer)();
  const isAddonSelected = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectIsAddonSelected);
  const costs = {};
  if (selectedHandsetVariant) {
    costs.handset = {
      name: selectedHandset === null || selectedHandset === void 0 ? void 0 : selectedHandset.productName,
      productType: _constants.PRODUCT_TYPES.HANDSET,
      ...selectedHandsetVariant,
      ...getCosts(selectedHandsetVariant)
    };
  }
  if (selectedPlanVariant) {
    costs.plan = {
      name: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.productName,
      productType: _constants.PRODUCT_TYPES.PLAN,
      ...selectedPlanVariant,
      ...getCosts(selectedPlanVariant)
    };
  }
  if (additionalPlans) {
    costs.additionalPlans = {
      name: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.productName,
      productType: _constants.PRODUCT_TYPES.PLAN,
      ...selectedPlanVariant,
      ...getAdditionalCosts(selectedPlanVariant, additionalPlans, isCustomer)
    };
  }
  if (selectedProductOfferingVariant.length) {
    costs.upsell = {
      items: selectedProductOfferingVariant.map(variant => ({
        name: variant.selectedVariant ? variant.selectedVariant.name : variant.name,
        price: variant.price,
        productType: variant.productType,
        selectedPrice: variant.selectedPrice
      })),
      ...getUpsellCosts(selectedProductOfferingVariant)
    };
  }
  if (selectedProductOfferingVariant.length && connectivityPlan.selected) {
    const {
      name,
      productOfferingPrice
    } = connectivityPlan.offering;
    const mappedPlan = {
      name,
      productType: _constants.PRODUCT_TYPES.CONNECTIVITY_PLAN,
      price: {
        durationAmount: productOfferingPrice[0].productOfferingTerm[0].duration.amount,
        durationUnit: productOfferingPrice[0].productOfferingTerm[0].duration.units,
        priceType: productOfferingPrice[0].priceType,
        priceUnit: productOfferingPrice[0].price.unit,
        priceValue: productOfferingPrice[0].price.value
      }
    };
    costs.connectivityPlan = {
      ...mappedPlan,
      ...getCosts(mappedPlan)
    };
  }
  if (selectedBroadbandVariant) {
    costs.broadband = {
      name: selectedBroadbandVariant === null || selectedBroadbandVariant === void 0 ? void 0 : selectedBroadbandVariant.productName,
      productType: _constants.PRODUCT_TYPES.BROADBAND,
      ...selectedBroadbandVariant,
      ...getCosts(selectedBroadbandVariant)
    };
  }
  if (selectedBusinessSolutionVariant) {
    var _selectedBusinessSolu, _selectedBusinessSolu2;
    const [productName, addonName] = (_selectedBusinessSolu = selectedBusinessSolutionVariant === null || selectedBusinessSolutionVariant === void 0 ? void 0 : (_selectedBusinessSolu2 = selectedBusinessSolutionVariant.productName) === null || _selectedBusinessSolu2 === void 0 ? void 0 : _selectedBusinessSolu2.split('+')) !== null && _selectedBusinessSolu !== void 0 ? _selectedBusinessSolu : [];
    const businessSolutionCosts = getCosts(selectedBusinessSolutionVariant);
    costs.businessSolution = {
      name: productName,
      productType: _constants.PRODUCT_TYPES.BUSINESS_SOLUTION,
      ...selectedBusinessSolutionVariant,
      ...businessSolutionCosts,
      upfrontCost: 0
    };
    if (isAddonSelected) {
      costs.addon = {
        name: addonName,
        productType: _constants.PRODUCT_TYPES.BUSINESS_SOLUTION,
        ...selectedBusinessSolutionVariant,
        ...businessSolutionCosts,
        termCost: 0
      };
    }
  }
  const termUnit = ((_costs$handset = costs.handset) === null || _costs$handset === void 0 ? void 0 : _costs$handset.termUnit) || ((_costs$plan = costs.plan) === null || _costs$plan === void 0 ? void 0 : _costs$plan.termUnit) || '';
  const termDuration = Math.max((_costs$handset$termDu = (_costs$handset2 = costs.handset) === null || _costs$handset2 === void 0 ? void 0 : _costs$handset2.termDuration) !== null && _costs$handset$termDu !== void 0 ? _costs$handset$termDu : 0, (_costs$plan$termDurat = (_costs$plan2 = costs.plan) === null || _costs$plan2 === void 0 ? void 0 : _costs$plan2.termDuration) !== null && _costs$plan$termDurat !== void 0 ? _costs$plan$termDurat : 0);
  const totalUpfrontCost = ((_costs$handset$upfron = (_costs$handset3 = costs.handset) === null || _costs$handset3 === void 0 ? void 0 : _costs$handset3.upfrontCost) !== null && _costs$handset$upfron !== void 0 ? _costs$handset$upfron : 0) + ((_costs$plan$upfrontCo = (_costs$plan3 = costs.plan) === null || _costs$plan3 === void 0 ? void 0 : _costs$plan3.upfrontCost) !== null && _costs$plan$upfrontCo !== void 0 ? _costs$plan$upfrontCo : 0) + ((_costs$upsell$totalUp = (_costs$upsell = costs.upsell) === null || _costs$upsell === void 0 ? void 0 : _costs$upsell.totalUpsellUpfrontCost) !== null && _costs$upsell$totalUp !== void 0 ? _costs$upsell$totalUp : 0) + ((_costs$connectivityPl = (_costs$connectivityPl2 = costs.connectivityPlan) === null || _costs$connectivityPl2 === void 0 ? void 0 : _costs$connectivityPl2.upfrontCost) !== null && _costs$connectivityPl !== void 0 ? _costs$connectivityPl : 0) + ((_costs$broadband$upfr = (_costs$broadband = costs.broadband) === null || _costs$broadband === void 0 ? void 0 : _costs$broadband.upfrontCost) !== null && _costs$broadband$upfr !== void 0 ? _costs$broadband$upfr : 0) + ((_costs$businessSoluti = (_costs$businessSoluti2 = costs.businessSolution) === null || _costs$businessSoluti2 === void 0 ? void 0 : _costs$businessSoluti2.upfrontCost) !== null && _costs$businessSoluti !== void 0 ? _costs$businessSoluti : 0) + ((_costs$addon$upfrontC = (_costs$addon = costs.addon) === null || _costs$addon === void 0 ? void 0 : _costs$addon.upfrontCost) !== null && _costs$addon$upfrontC !== void 0 ? _costs$addon$upfrontC : 0);
  const totalTermCost = ((_costs$handset$termCo = (_costs$handset4 = costs.handset) === null || _costs$handset4 === void 0 ? void 0 : _costs$handset4.termCost) !== null && _costs$handset$termCo !== void 0 ? _costs$handset$termCo : 0) + ((_costs$plan$termCost = (_costs$plan4 = costs.plan) === null || _costs$plan4 === void 0 ? void 0 : _costs$plan4.termCost) !== null && _costs$plan$termCost !== void 0 ? _costs$plan$termCost : 0) + ((_costs$additionalPlan = (_costs$additionalPlan2 = costs.additionalPlans) === null || _costs$additionalPlan2 === void 0 ? void 0 : _costs$additionalPlan2.totalCost) !== null && _costs$additionalPlan !== void 0 ? _costs$additionalPlan : 0) + ((_costs$upsell$totalUp2 = (_costs$upsell2 = costs.upsell) === null || _costs$upsell2 === void 0 ? void 0 : _costs$upsell2.totalUpsellReccuringCost) !== null && _costs$upsell$totalUp2 !== void 0 ? _costs$upsell$totalUp2 : 0) + ((_costs$connectivityPl3 = (_costs$connectivityPl4 = costs.connectivityPlan) === null || _costs$connectivityPl4 === void 0 ? void 0 : _costs$connectivityPl4.termCost) !== null && _costs$connectivityPl3 !== void 0 ? _costs$connectivityPl3 : 0) + ((_costs$broadband$term = (_costs$broadband2 = costs.broadband) === null || _costs$broadband2 === void 0 ? void 0 : _costs$broadband2.termCost) !== null && _costs$broadband$term !== void 0 ? _costs$broadband$term : 0) + ((_costs$businessSoluti3 = (_costs$businessSoluti4 = costs.businessSolution) === null || _costs$businessSoluti4 === void 0 ? void 0 : _costs$businessSoluti4.termCost) !== null && _costs$businessSoluti3 !== void 0 ? _costs$businessSoluti3 : 0);
  const totalTermCostAfterDiscount = ((_costs$handset$termCo2 = (_costs$handset5 = costs.handset) === null || _costs$handset5 === void 0 ? void 0 : _costs$handset5.termCostAfterDiscount) !== null && _costs$handset$termCo2 !== void 0 ? _costs$handset$termCo2 : 0) + ((_costs$plan$termCostA = (_costs$plan5 = costs.plan) === null || _costs$plan5 === void 0 ? void 0 : _costs$plan5.termCostAfterDiscount) !== null && _costs$plan$termCostA !== void 0 ? _costs$plan$termCostA : 0) + ((_costs$additionalPlan3 = (_costs$additionalPlan4 = costs.additionalPlans) === null || _costs$additionalPlan4 === void 0 ? void 0 : _costs$additionalPlan4.totalCostAfterDiscount) !== null && _costs$additionalPlan3 !== void 0 ? _costs$additionalPlan3 : 0) + ((_costs$upsell$totalUp3 = (_costs$upsell3 = costs.upsell) === null || _costs$upsell3 === void 0 ? void 0 : _costs$upsell3.totalUpsellReccuringCostAfterDiscount) !== null && _costs$upsell$totalUp3 !== void 0 ? _costs$upsell$totalUp3 : 0) + ((_costs$connectivityPl5 = (_costs$connectivityPl6 = costs.connectivityPlan) === null || _costs$connectivityPl6 === void 0 ? void 0 : _costs$connectivityPl6.termCostAfterDiscount) !== null && _costs$connectivityPl5 !== void 0 ? _costs$connectivityPl5 : 0) + ((_costs$broadband$term2 = (_costs$broadband3 = costs.broadband) === null || _costs$broadband3 === void 0 ? void 0 : _costs$broadband3.termCostAfterDiscount) !== null && _costs$broadband$term2 !== void 0 ? _costs$broadband$term2 : 0) + ((_costs$businessSoluti5 = (_costs$businessSoluti6 = costs.businessSolution) === null || _costs$businessSoluti6 === void 0 ? void 0 : _costs$businessSoluti6.termCostAfterDiscount) !== null && _costs$businessSoluti5 !== void 0 ? _costs$businessSoluti5 : 0) + ((_costs$addon$termCost = (_costs$addon2 = costs.addon) === null || _costs$addon2 === void 0 ? void 0 : _costs$addon2.termCostAfterDiscount) !== null && _costs$addon$termCost !== void 0 ? _costs$addon$termCost : 0);
  const termStart = 0;
  const handsetTermCost = (_costs$handset6 = costs.handset) === null || _costs$handset6 === void 0 ? void 0 : _costs$handset6.termCost;
  const handsetUpfrontCost = (_costs$handset7 = costs.handset) === null || _costs$handset7 === void 0 ? void 0 : _costs$handset7.upfrontCost;

  // display discount based on user status
  let discountPrices = calcPriceDiscount((_costs$handset8 = costs.handset) === null || _costs$handset8 === void 0 ? void 0 : _costs$handset8.discount);
  const costsPayload = {
    ...costs,
    termDuration,
    termUnit,
    totalUpfrontCost,
    totalTermCost,
    totalTermCostAfterDiscount,
    termStart,
    handsetTermCost,
    handsetUpfrontCost,
    discountPrices
  };
  const pricesCosts = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectPricesCosts);
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  (0, _react.useEffect)(() => {
    dispatch((0, _recommendationActions.setPricesCosts)(costsPayload));
  }, [termDuration, termUnit, totalUpfrontCost, totalTermCost, totalTermCostAfterDiscount, termStart, handsetTermCost, handsetUpfrontCost]);
  return pricesCosts || costsPayload;
};
exports.useRecommendationCosts = useRecommendationCosts;